import React from 'react';
import PropTypes from 'prop-types';
import SUPPORTED_FLAGS from './SUPPORTED_FLAGS';

const countryMap = {
  australia: 'au',
  canada: 'ca',
  china: 'cn',
  hongkong: 'hk',
  newzealand: 'nz',
  singapore: 'sg',
  unitedstates: 'us',
  unitedkingdom: 'gb',
  ireland: 'ie',
  sweden: 'se',
  germany: 'de',
  netherlands: 'nl',
  belgium: 'be',
  austria: 'at',
  switzerland: 'ch',
  france: 'fr',
  italy: 'it',
  spain: 'es',
};

const Flag = ({ country }) => {
  const countryAbbreviation = countryMap[country] || country;
  return (
    <svg className="c-flag">
      <use xlinkHref={`#flag-${countryAbbreviation}`} />
    </svg>
  );
};

export default Flag;

Flag.propTypes = {
  country: PropTypes.oneOf([
    'australia',
    'canada',
    'china',
    'hongkong',
    'newzealand',
    'singapore',
    'unitedstates',
    'unitedkingdom',
    'ireland',
    'sweden',
    'germany',
    'netherlands',
    'belgium',
    'austria',
    'switzerland',
    'france',
    'italy',
    'spain',
    ...SUPPORTED_FLAGS,
  ]).isRequired,
};
